import { Link } from '@inertiajs/react';

export default function RoundIconBtn({ icon, href, onClick, className = '', title, active = false }) {
    const baseClasses = `w-10 h-10 flex items-center justify-center rounded-full transition-colors ${active ? 'bg-white/20 text-white' : 'hover:bg-white/10 text-slate-400 hover:text-white'
        } ${className}`;

    if (href) {
        return (
            <Link href={href} className={baseClasses} title={title}>
                <span className="material-symbols-outlined text-xl">{icon}</span>
            </Link>
        );
    }

    return (
        <button onClick={onClick} className={baseClasses} title={title} type="button">
            <span className="material-symbols-outlined text-xl">{icon}</span>
        </button>
    );
}
